import { render, staticRenderFns } from "./appConfig.vue?vue&type=template&id=186ff0b9&scoped=true&"
import script from "./appConfig.vue?vue&type=script&lang=js&"
export * from "./appConfig.vue?vue&type=script&lang=js&"
import style0 from "./appConfig.vue?vue&type=style&index=0&id=186ff0b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ff0b9",
  null
  
)

export default component.exports